import React from 'react';
import { Field } from 'react-final-form';

import { Input } from 'components/ui';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const FormInput = ({
  name,
  placeholder,
  type = 'text',
  dataId = 'form-input',
  'data-testid': dataTestId = undefined,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <Field name={name}>
      {({ input, meta }) => {
        return (
          <>
            <Input
              type={type}
              onKeyDown={
                type === 'number' ?
                ((evt) =>
                  ['e', 'E', '+', '-'].includes(evt.key) &&
                  evt.preventDefault()) : undefined
              }
              data-id={dataId}
              inputProps={{
                ...props.inputProps,
                'data-testid': dataTestId
              }}
              {...props}
              {...input}
              placeholder={placeholder}
              onChange={(e) => {
                if (!e.target.value) {
                  input?.onChange?.(e.target.value);
                } else {
                  input?.onChange?.(
                    type === 'number' && props?.valueType !== 'string'
                      ? +e.target.value
                      : e.target.value
                  );
                }
              }}
              variant="outlined"
              error={meta.touched && meta.error}
              helperText={meta.touched && t(meta.error)}
            />
          </>
        );
      }}
    </Field>
  );
};

export default FormInput;
